var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "log-container" },
    [
      _c(
        "el-collapse",
        { attrs: { model: 1 }, on: { change: _vm.handleChange } },
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "操作日志", name: "1" } },
            [
              _vm.logs.length > 0
                ? _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "infinite-scroll",
                          rawName: "v-infinite-scroll",
                          value: _vm.load,
                          expression: "load",
                        },
                      ],
                      staticClass: "infinite-list",
                      staticStyle: { overflow: "auto", "max-height": "250px" },
                    },
                    _vm._l(_vm.logs, function (item, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "infinite-list-item" },
                        [
                          _c("p", { staticClass: "content" }, [
                            _vm._v(_vm._s(item.content)),
                          ]),
                          _c("span", { staticClass: "time" }, [
                            _vm._v(_vm._s(item.createTime)),
                          ]),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                "popper-class": "log-user",
                                placement: "top-start",
                                title: _vm.overview
                                  ? _vm.overview.name
                                  : "该账户没有绑定用户",
                                width: "200",
                                trigger: "click",
                              },
                            },
                            [
                              _vm.overview
                                ? _c(
                                    "div",
                                    { staticClass: "popover-content" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "工号：" +
                                            _vm._s(
                                              _vm.overview.staffId ||
                                                _vm.overview.id
                                            )
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          "手机号：" +
                                            _vm._s(_vm.overview.phone)
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          "所属部门：" +
                                            _vm._s(_vm.overview.departmentName)
                                        ),
                                      ]),
                                      _c("span", [
                                        _vm._v(
                                          "职位：" +
                                            _vm._s(_vm.overview.positionName)
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  staticClass: "user",
                                  attrs: { slot: "reference" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.overviewHandler(item.accountId)
                                    },
                                  },
                                  slot: "reference",
                                },
                                [_vm._v(_vm._s(item.userName))]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c("el-empty", { attrs: { description: "还没有操作" } }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }